import React from 'react';
import * as Fi from 'react-icons/fi';
import { Modal } from 'react-bootstrap';
import _ from 'underscore';

import { DatePicker, Select, Form } from 'ui/components';
import { SkeletonsForm } from 'ui/components/skeleton';

import { formatDate } from 'utilities/common';

import { FormItems } from '../../../list/component/form/items';
import { FormLocation } from 'ui/screens/authorized/_shared';
import { useSelector } from 'react-redux';

const initialState = {
  ref_code: '',
  origin: null,
  destination: null,
  pickup_note: '',
  instruction: '',
  cod_value: null,
  unit_price: null,
  items: null,
  etd_at: {
    default: new Date(),
    formatted: formatDate(new Date(), 'YYYY-MM-DD'),
  },
  etd_time: '',
  eta_at: {
    default: new Date(),
    formatted: formatDate(new Date(), 'YYYY-MM-DD'),
  },
  eta_time: '',
  loading: true,
  is_add_pickup: false,
  is_add_drop: false,
  errors: {},
  submitted: false,
  showForm: false,
  showFormEdit: false,
  showFormOrigin: false,
  showFormOriginEdit: false,
};

export const Shipments = ({
  customer,
  data,
  service,
  serviceType,
  onInputChanges,
}) => {
  const Session = useSelector((state) => state.Auth?.session);

  const [
    {
      ref_code,
      origin,
      destination,
      pickup_note,
      instruction,
      cod_value,
      unit_price,
      items,
      etd_at,
      etd_time,
      eta_at,
      eta_time,
      loading,
      is_add_pickup,
      is_add_drop,
      errors,
      submitted,
      showForm,
      showFormEdit,
      showFormOrigin,
      showFormOriginEdit,
    },
    setState,
  ] = React.useState(initialState);
  const [privilege, setPrivilege] = React.useState(null);

  const $getPrivilege = async () => {
    const payload = {};

    const location = _.findWhere(Session?.privileges, {
      service: 'nvo.platform.location',
    });

    if (location) {
      payload.location = location;
    }

    setPrivilege(payload);
  };

  const $handleClose = () => {
    setState((prevState) => ({
      ...prevState,
      showForm: false,
      showFormEdit: false,
      showFormOrigin: false,
      showFormOriginEdit: false,
    }));
  };

  React.useEffect(() => {
    setTimeout(() => {
      setState((prevState) => ({
        ...prevState,
        loading: false,
      }));
    }, 2000);
  }, [loading]);

  React.useEffect(() => {
    if (_.isEmpty(errors)) return;

    setTimeout(() => {
      setState((prevState) => ({
        ...prevState,
        errors: {},
      }));
    }, 6000);
  }, [errors]);

  React.useEffect(() => {
    if (!data) return;

    setState((prevState) => ({
      ...prevState,
      loading: true,
      ref_code: data?.ref_code,
      origin: data?.origin,
      destination: data?.destination,
      pickup_note: data?.pickup_note,
      instruction: data?.instruction,
      cod_value: data?.cod_value,
      unit_price: data?.unit_price,
      items: data?.items || null,
      etd_at: {
        default: new Date(data?.etd_at),
        formatted: formatDate(data?.etd_at, 'YYYY-MM-DD'),
      },
      etd_time: formatDate(data?.etd_at, 'HH:mm'),
      eta_at: {
        default: new Date(data?.eta_at),
        formatted: formatDate(data?.eta_at, 'YYYY-MM-DD'),
      },
      eta_time: formatDate(data?.eta_at, 'HH:mm'),
    }));
  }, [data]);

  React.useEffect(() => {
    const input = {
      ref_code,
      origin,
      destination,
      pickup_note,
      instruction,
      cod_value,
      unit_price,
      items,
      etd_at,
      etd_time,
      eta_at,
      eta_time,
    };

    onInputChanges(input);
  }, [
    ref_code,
    origin,
    destination,
    pickup_note,
    instruction,
    cod_value,
    unit_price,
    items,
    etd_at,
    etd_time,
    eta_at,
    eta_time,
  ]);

  React.useEffect(() => {
    $getPrivilege();
  }, [Session]);

  return (
    <div className="" id="form-shipment">
      <div className="mb-3 px-4 py-2">
        {service?.auto_manifest ? (
          <div className="row ">
            <div className="col-md-6 p-3 pt-4 border-end">
              <div className="hr-text hr-text-left text-primary mb-3 ">
                Origin
              </div>
              {loading ? (
                <SkeletonsForm count={3} />
              ) : (
                <div>
                  <div className="mb-3">
                    <label className="form-label required fs-8">
                      Lokasi Pickup
                    </label>
                    <div className="row">
                      <div className={'col-10 pe-0'}>
                        <Select.Remote
                          label=""
                          placeholder=""
                          url="/location"
                          value={origin}
                          initialValue={origin?.id}
                          keys={origin?.id || customer?.id || loading}
                          row={(d) => {
                            return { value: d.id, label: d.name };
                          }}
                          onSelected={(c) =>
                            setState((prevState) => ({
                              ...prevState,
                              origin: c,
                            }))
                          }
                          errors={errors?.origin}
                          disabled={is_add_drop}
                        />
                      </div>
                      <div className="col-2 text-end ps-0">
                        {origin ? (
                          <button
                            type="button"
                            className="btn btn-primary rounded px-2"
                            style={{ minHeight: 30, minWidth: '80%' }}
                            onClick={() =>
                              setState((prevState) => ({
                                ...prevState,
                                showFormOriginEdit: true,
                              }))
                            }
                            disabled={
                              Session?.privileges &&
                              privilege?.location?.action !== 'manage'
                            }
                          >
                            <Fi.FiEdit color="white" />
                          </button>
                        ) : (
                          <button
                            type="button"
                            className="btn btn-primary rounded px-2"
                            style={{ minHeight: 30, minWidth: '80%' }}
                            onClick={() =>
                              setState((prevState) => ({
                                ...prevState,
                                showFormOrigin: true,
                              }))
                            }
                            disabled={
                              origin ||
                              (Session?.privileges &&
                                privilege?.location?.action !== 'manage')
                            }
                          >
                            <Fi.FiPlus color="white" />
                          </button>
                        )}
                      </div>

                      {origin && (
                        <div className="col-12">
                          <div className="card card-form mt-2">
                            <div className="card-body text-uppercase text-muted fs-9 p-2">
                              <p>{origin?.address}</p>

                              <small>{`${origin?.region?.district_name}, ${origin?.region?.regency_name}, ${origin?.region?.province_name}`}</small>
                              <br />
                              <small>
                                CP: {origin?.contact_person}{' '}
                                {`/ ${origin?.phone_number}`}
                              </small>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-8">
                      <div className="mb-3">
                        <label className="form-label fs-8 required">
                          Jadwal Pickup
                        </label>
                        <div
                          className={
                            errors?.etd_at ? 'border border-danger rounded' : ''
                          }
                        >
                          {is_add_drop ? (
                            <Form.Input
                              required
                              type="text"
                              value={etd_at?.formatted}
                              disabled
                            />
                          ) : (
                            <DatePicker
                              type="normal"
                              value={etd_at?.default || null}
                              format="dd/MM/yyyy"
                              onChange={(date) =>
                                setState((prevState) => ({
                                  ...prevState,
                                  etd_at: {
                                    default: date,
                                    formatted: formatDate(date, 'YYYY-MM-DD'),
                                  },
                                }))
                              }
                            />
                          )}
                        </div>
                        {errors?.etd_at && (
                          <div
                            className="invalid-feedback"
                            style={{ display: 'block' }}
                          >
                            {errors?.etd_at}
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="col-4">
                      <Form.Time
                        label="Waktu Pickup"
                        value={etd_time}
                        onChange={(e) =>
                          setState((prevState) => ({
                            ...prevState,
                            etd_time: e,
                          }))
                        }
                        disabled={is_add_drop}
                        error={errors?.etd_at}
                        required
                      />
                    </div>
                  </div>

                  <Form.Textbox
                    label="Shipper Note"
                    value={pickup_note}
                    name="pickup_note"
                    onChange={(e) =>
                      setState((prevState) => ({
                        ...prevState,
                        pickup_note: e?.target?.value,
                      }))
                    }
                  />
                </div>
              )}
            </div>
            <div className="col-md-6 p-3 pt-4">
              <div className="hr-text hr-text-left text-primary mb-3 ">
                Destination
              </div>
              {loading ? (
                <SkeletonsForm count={3} />
              ) : (
                <div>
                  <div className="mb-3">
                    <label className="form-label required fs-8">
                      Alamat Penerima
                    </label>
                    <div className="row">
                      <div className={'col-10 pe-0'}>
                        <Select.Remote
                          label=""
                          placeholder=""
                          url="/location"
                          value={destination}
                          initialValue={destination?.id}
                          keys={destination?.id || customer?.id}
                          row={(d) => {
                            return { value: d.id, label: d.name };
                          }}
                          onSelected={(c) =>
                            setState((prevState) => ({
                              ...prevState,
                              destination: c,
                            }))
                          }
                          disabled={is_add_pickup}
                          errors={errors?.destination}
                        />
                      </div>
                      <div className="col-2 text-end ps-0">
                        {destination ? (
                          <button
                            type="button"
                            className="btn btn-primary rounded px-2"
                            style={{ minHeight: 30, minWidth: '80%' }}
                            onClick={() =>
                              setState((prevState) => ({
                                ...prevState,
                                showFormEdit: true,
                              }))
                            }
                            disabled={
                              Session?.privileges &&
                              privilege?.location?.action !== 'manage'
                            }
                          >
                            <Fi.FiEdit color="white" />
                          </button>
                        ) : (
                          <button
                            type="button"
                            className="btn btn-primary rounded px-2"
                            style={{ minHeight: 30, minWidth: '80%' }}
                            onClick={() =>
                              setState((prevState) => ({
                                ...prevState,
                                showForm: true,
                              }))
                            }
                            disabled={
                              destination ||
                              (Session?.privileges &&
                                privilege?.location?.action !== 'manage')
                            }
                          >
                            <Fi.FiPlus color="white" />
                          </button>
                        )}
                      </div>
                      {destination && (
                        <div className="col-12">
                          <div className="card card-form mt-2">
                            <div className="card-body text-uppercase text-muted fs-9 p-2">
                              <p>{destination?.address}</p>

                              <small>{`${destination?.region?.district_name}, ${destination?.region?.regency_name}, ${destination?.region?.province_name}`}</small>
                              <br />
                              <small>
                                CP: {destination?.contact_person}{' '}
                                {`/ ${destination?.phone_number}`}
                              </small>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-8">
                      <div className="mb-3">
                        <label className="form-label fs-8 required">
                          Jadwal Penerimaan
                        </label>
                        <div
                          className={
                            errors?.eta_at ? 'border border-danger rounded' : ''
                          }
                        >
                          {is_add_pickup ? (
                            <Form.Input
                              required
                              type="text"
                              value={eta_at?.formatted}
                              disabled
                            />
                          ) : (
                            <DatePicker
                              type="normal"
                              value={eta_at?.default || null}
                              format="dd/MM/yyyy"
                              onChange={(date) =>
                                setState((prevState) => ({
                                  ...prevState,
                                  eta_at: {
                                    default: date,
                                    formatted: formatDate(date, 'YYYY-MM-DD'),
                                  },
                                }))
                              }
                              isShowTrigger
                            />
                          )}
                        </div>
                        {errors?.eta_at && (
                          <div
                            className="invalid-feedback"
                            style={{ display: 'block' }}
                          >
                            {errors?.eta_at}
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="col-4">
                      <Form.Time
                        label="Waktu Terima"
                        value={eta_time}
                        onChange={(e) =>
                          setState((prevState) => ({
                            ...prevState,
                            eta_time: e,
                          }))
                        }
                        required
                        disabled={is_add_pickup}
                        error={errors?.eta_at}
                      />
                    </div>
                  </div>

                  <Form.Textbox
                    label="Delivery Note"
                    value={instruction}
                    name="instruction"
                    onChange={(e) =>
                      setState((prevState) => ({
                        ...prevState,
                        instruction: e?.target?.value,
                      }))
                    }
                  />
                </div>
              )}
            </div>

            <div className="col-md-12 border-top p-3">
              <FormItems
                initialValue={data?.items}
                loading={loading}
                submitted={submitted}
                errors={errors?.items}
                setItem={(e) =>
                  setState((prevState) => ({
                    ...prevState,
                    items: e,
                  }))
                }
                serviceType={serviceType}
              />
            </div>
          </div>
        ) : (
          <div className="row">
            <div className="col-md-12 p-3 pt-4">
              <div className="hr-text hr-text-left text-primary mb-3">
                Destination
              </div>
              {loading ? (
                <SkeletonsForm count={2} />
              ) : (
                <div className="row">
                  <div className="col-sm-8">
                    <label className="form-label fs-8">Alamat Penerima</label>
                    <div className="row mb-3">
                      <div className={'col-10 pe-0'}>
                        <Select.Remote
                          label=""
                          placeholder=""
                          url="/location"
                          initialValue={destination?.id}
                          keys={data?.destination?.id || destination?.id}
                          row={(d) => {
                            return { value: d.id, label: d.name };
                          }}
                          onSelected={(c) =>
                            setState((prevState) => ({
                              ...prevState,
                              destination: c,
                            }))
                          }
                          errors={errors?.destination}
                        />
                      </div>
                      <div className="col-2 text-end ps-0">
                        {destination ? (
                          <button
                            type="button"
                            className="btn btn-primary rounded px-2"
                            style={{ minHeight: 30, minWidth: '80%' }}
                            onClick={() =>
                              setState((prevState) => ({
                                ...prevState,
                                showFormEdit: true,
                              }))
                            }
                            disabled={
                              Session?.privileges &&
                              privilege?.location?.action !== 'manage'
                            }
                          >
                            <Fi.FiEdit color="white" />
                          </button>
                        ) : (
                          <button
                            type="button"
                            className="btn btn-primary rounded px-2"
                            style={{ minHeight: 30, minWidth: '80%' }}
                            onClick={() =>
                              setState((prevState) => ({
                                ...prevState,
                                showForm: true,
                              }))
                            }
                            disabled={
                              destination ||
                              (Session?.privileges &&
                                privilege?.location?.action !== 'manage')
                            }
                          >
                            <Fi.FiPlus color="white" />
                          </button>
                        )}
                      </div>
                      {destination && (
                        <div className="col-12">
                          <div className="card card-form mt-2">
                            <div className="card-body text-uppercase text-muted fs-9 p-2">
                              <p>{destination?.address}</p>

                              <small>{`${destination?.region?.district_name}, ${destination?.region?.regency_name}, ${destination?.region?.province_name}`}</small>
                              <br />
                              <small>
                                CP: {destination?.contact_person}{' '}
                                {`/ ${destination?.phone_number}`}
                              </small>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>

                    <div className="row">
                      <div className="col-8">
                        <div className="mb-3">
                          <label className="form-label fs-8">
                            Jadwal Penerimaan
                          </label>
                          <div
                            className={
                              errors?.eta_at
                                ? 'border border-danger rounded'
                                : ''
                            }
                          >
                            <DatePicker
                              type="normal"
                              value={eta_at?.default || null}
                              format="dd/MM/yyyy"
                              onChange={(date) =>
                                setState((prevState) => ({
                                  ...prevState,
                                  eta_at: {
                                    default: date,
                                    formatted: formatDate(date, 'YYYY-MM-DD'),
                                  },
                                }))
                              }
                              isShowTrigger
                            />
                          </div>
                          {errors?.eta_at && (
                            <div
                              className="invalid-feedback"
                              style={{ display: 'block' }}
                            >
                              {errors?.eta_at}
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="col-4">
                        <Form.Time
                          label="Waktu Penerimaan"
                          value={eta_time}
                          onChange={(e) =>
                            setState((prevState) => ({
                              ...prevState,
                              eta_time: e,
                            }))
                          }
                          error={errors?.eta_at}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-4">
                    <Form.Input
                      label="Customer Reference Number"
                      type="text"
                      value={ref_code}
                      onChange={(e) =>
                        setState((prevState) => ({
                          ...prevState,
                          ref_code: e?.target?.value,
                        }))
                      }
                    />
                    <div className='row'>
                      <div className='col-6'>
                        <Form.Input
                          label="Unit Price"
                          type="number"
                          value={unit_price}
                          onChange={(e) =>
                            setState((prevState) => ({
                              ...prevState,
                              unit_price: e?.target?.valueNumber,
                            }))
                          }
                        />
                      </div>
                      <div className='col-6'>
                        <Form.Input
                          label="COD Value"
                          type="number"
                          value={cod_value}
                          onChange={(e) =>
                            setState((prevState) => ({
                              ...prevState,
                              cod_value: e?.target?.valueNumber,
                            }))
                          }
                        />
                      </div>
                    </div>
                  </div>

                  <Form.Textbox
                    label="Delivery Note"
                    value={instruction}
                    name="instruction"
                    onChange={(e) =>
                      setState((prevState) => ({
                        ...prevState,
                        instruction: e?.target?.value,
                      }))
                    }
                  />
                </div>
              )}

              <FormItems
                initialValue={data?.items}
                loading={loading}
                submitted={submitted}
                errors={errors?.items}
                setItem={(e) =>
                  setState((prevState) => ({
                    ...prevState,
                    items: e,
                  }))
                }
                serviceType={serviceType}
              />
            </div>
          </div>
        )}
      </div>

      <Modal
        show={showForm}
        onHide={$handleClose}
        backdrop="static"
        centered
        scrollable
        size="xl"
        enforceFocus={true}
      >
        <Modal.Header closeButton>
          <Modal.Title>Tambah Alamat</Modal.Title>
        </Modal.Header>
        <FormLocation
          onClose={(e) => {
            setState((prevState) => ({
              ...prevState,
              destination: e,
              showForm: false,
            }));
          }}
          onSuccess={(e) => {
            setState((prevState) => ({
              ...prevState,
              destination: e,
              showForm: false,
            }));
          }}
          customer_id={customer?.id}
          type={customer?.id ? 'drop_point' : 'point'}
          selected
        />
      </Modal>

      <Modal
        show={showFormOrigin}
        onHide={$handleClose}
        backdrop="static"
        centered
        scrollable
        size="xl"
        enforceFocus={true}
      >
        <Modal.Header closeButton>
          <Modal.Title>Tambah Alamat</Modal.Title>
        </Modal.Header>
        <FormLocation
          onClose={(e) => {
            setState((prevState) => ({
              ...prevState,
              origin: e,
              showFormOrigin: false,
            }));
          }}
          onSuccess={(e) => {
            setState((prevState) => ({
              ...prevState,
              origin: e,
              showFormOrigin: false,
            }));
          }}
          customer_id={customer?.id}
          type={customer?.id ? 'pickup_point' : 'point'}
          selected
        />
      </Modal>

      <Modal
        show={showFormEdit}
        onHide={$handleClose}
        backdrop="static"
        centered
        scrollable
        size="xl"
        enforceFocus={true}
      >
        <Modal.Header closeButton>
          <Modal.Title>Perbaharui Alamat</Modal.Title>
        </Modal.Header>
        <FormLocation
          data={destination}
          onClose={(e) => {
            setState((prevState) => ({
              ...prevState,
              destination: e,
              showFormEdit: false,
            }));
          }}
          onSuccess={(e) => {
            setState((prevState) => ({
              ...prevState,
              destination: e,
              showFormEdit: false,
            }));
          }}
          customer_id={customer?.id}
          type={customer?.id ? 'drop_point' : 'point'}
          selected
        />
      </Modal>

      <Modal
        show={showFormOriginEdit}
        onHide={$handleClose}
        backdrop="static"
        centered
        scrollable
        size="xl"
        enforceFocus={true}
      >
        <Modal.Header closeButton>
          <Modal.Title>Perbaharui Alamat</Modal.Title>
        </Modal.Header>
        <FormLocation
          data={origin}
          onClose={(e) => {
            setState((prevState) => ({
              ...prevState,
              origin: e,
              showFormOriginEdit: false,
            }));
          }}
          onSuccess={(e) => {
            setState((prevState) => ({
              ...prevState,
              origin: e,
              showFormOriginEdit: false,
            }));
          }}
          customer_id={customer?.id}
          type={customer?.id ? 'pickup_point' : 'point'}
          selected
        />
      </Modal>
    </div>
  );
};
